module.exports = __webpack_public_path__ + "static/media/top.be126318.png";